export default [
	/* 	{
		path: "/pros/reviews/schedule-review",
		exact: true,
		policy: "providerAuth",
		component: "ScheduleReview/ScheduleReview",
		mui: true,
	}, */
];
